import React, {useState, useEffect, useMemo} from 'react';
import * as store from './store'
import {AES} from 'crypto-es/lib/aes';
import CryptoES from 'crypto-es';
import {userStore} from "./store";
import {Tool} from "../Config/Tool";
import {history} from '../history'
import {apiConfig} from "./api";
import {observer} from "mobx-react";
import {configure} from "mobx"
import {fixD3} from "../Components/dateRange";
import {localStore} from "../storage";

const key1 = '90R1XU#DEDghEObz';
const key2 = '&$n$^VGfTT%VDdeX';
const {enc: {Utf8}, mode, pad} = CryptoES;
configure({
    enforceActions: "never",
})

const au = {
    task: 0,
    timer: 0
}
export const onErrorChangeApi = () => {
    clearTimeout(au.timer)
    au.task = () => {
        au.task = null;
        let list = [];
        try {
            list.push(...JSON.parse(localStore.dm))
        } catch (e) {
        }
        if (list.length) {
            autoApi()
        } else {
            getInit(autoApi)
        }
    };
    au.timer = setTimeout(() => {
        if (au.task) au.task()
    }, 2e3)
}


export function autoApi({domains} = {}) {
    if(window.localStorage.debug)return userStore.domain='https://api.u366.cc'
    const me = getBaseApi().replace(/^https?:\/\//, '');
    domains = domains || [];
    let list = [me];
    if (domains.length) {
        localStore.dm = JSON.stringify(domains)
        list.push(...domains)
    } else {
        try {
            list.push(...JSON.parse(localStore.dm))
        } catch (e) {
        }
    }
    const v = {}
    list = list.filter(a => {
        if (a[v]) return;
        return v[a] = 1
    })
    if (list.length) {
        let ok = 0

        function run(fn) {
            if (ok) return;
            fn(list)
            if (list.length) setTimeout(function () {
                run(fn)
            }, 60)
        }

        run(() => {
            const v = list.pop()
            getData('@test', {domain: v}, () => {
                if (!ok) {
                    ok = 1;
                    userStore.domain = v
                }
            })
        })
    }
}

export const getInit = (done, fail, api) => {
    getData(
        '@init',
        undefined,
        (data) => {
            Object.assign(userStore, data)
            done && done(data)
        },
        () => {
            const ori = getApi()
            if (getBaseApi() === ori || api === ori) {
                fail && fail()
            } else {
                getInit(done, fail, ori)
            }
        },
        undefined,
        undefined,
        api
    )
}


export const encrypt = function (s, k1 = key1, k2 = key2) {
    return AES.encrypt(s, Utf8.parse(k1), {
        iv: Utf8.parse(k2),
        mode: mode.CBC,
        padding: pad.Pkcs7
    }).toString()
};
export const service = {}

function f401(er) {
    if (/login/.test(window.location.pathname)) return;
    store.userStore.clear();
    return history.push('/')
}


const getUrl = (k, p) => {
    const {u} = apiConfig[k] || {};
    if (typeof u === "function") {
        return '/' + u(p);
    }
    return u ? '/' + u : k.substr(1)
};

export const clearCache = (k) => {
    Object.keys(localStore).forEach(n => {
        if (n.indexOf('@' + k) === 0) localStore.removeItem(n)
    })
}

const gCk = (path, params) => (path + (params ? JSON.stringify(params) : '')).replace(/[\/@'"{}]/g, '');
const clean = (path, params) => {
    const cacheKey = gCk(path, params);
    localStore.removeItem(cacheKey);
}
const getCache = (path, params) => {
    const cfg = apiConfig[path];
    let d;
    const cacheKey = gCk(path, params);
    if (cfg) {
        const k = '_cle'
        let {t, clear} = cfg;
        if (typeof t === 'function') t = t(params)
        let o = {};
        if (clear) {
            let kv = ''
            try {
                kv = localStore.getItem(k) || '';
            } catch (e) {

            }
            kv = kv.replace(',' + cacheKey, '');
            kv += ',' + cacheKey;
            localStore.setItem(k, kv);
        }
        try {
            o = JSON.parse(localStore.getItem(cacheKey)) || {}
        } catch (e) {
        }
        if (t && +o.t + t > Date.now()) d = o.v;
    }
    return [d, (cfg && cfg.t) ? json => {
        localStore.setItem(cacheKey, JSON.stringify({t: Date.now(), v: json}));
    } : () => 0]
};
const reqList = {};
const req = (url, ff, after, stop, pa, postData, ch) => {
    const k = url + JSON.stringify(ff);
    if (ch && ch.length !== 0) return new Promise((resolve => {
        delete reqList[k];
        setTimeout(() => resolve(ch), 10)
    }));
    let p = reqList[k];
    const autoApiOnFail = (e) => {
        if (/\/test\?/.test(url)) return;
        if (/^Failed /.test(e.message)) onErrorChangeApi();
    }
    if (!p) {
        p = reqList[k] = fetch(url, ff)
            .then(res => {
                if (res.status === 401) return f401();
                return new Promise((resolve) => {
                    res.json().then(r => {
                        resolve(r)
                    }).catch(() => {
                        resolve({
                            status: res.status
                        })
                    })
                })
            }).catch(e => {
                autoApiOnFail(e)
                return e
            })
    }
    const c = () => delete reqList[k];
    return new Promise(((resolve, reject) => {
        p.then(res => {
            if (stop()) return;
            c();
            resolve(res)
        }).catch(e => {
            if (stop()) return;
            c();
            reject(e)
        })
    }));
};

export const getBaseApi = (ctx = {override: {}}) => {
    const d = ctx.override.domain || userStore.domain;
    return getApi(d);
}
export const getData = (pa, param, success, err, type = 'GET', stop = () => 0, tmpApi) => {
    const orig = {...param};
    if (param) Object.keys(param).forEach(a => {
        const v = param[a]
        if (v === '' || v === undefined || v === null) delete param[a]
    })
    const ctx = {
        override: {}
    };
    const [ch, setCache] = getCache(pa, param);
    let path = pa;
    const {done, fail, before, after, p,h} = apiConfig[path] || {};
    if (before) {
        const dd = before.call(ctx, param);
        if (dd !== undefined) param = dd;
    }
    type = p === undefined ? type : ['GET', 'POST', 'PUT', 'DELETE'][p];
    const postData = !/post/gi.test(type) ? '' : param;
    const isV2 = path[0] === '@';
    if (isV2) path = getUrl(path, orig);
    let apiV2 = tmpApi || getBaseApi(ctx);
    if (!postData && param) {
        path += '?';
        const l = [];
        Object.keys(param).forEach(k => {
            l.push(k + '=' + param[k])
        });
        path += l.join('&');
    }
    let url = path;
    const header = {
        'Content-Type': 'application/json',
    };
    const whenFail = (err, error) => {
        if (fail) {
            fail(err, orig);
        } else {
            if (err) Tool.alert(fmtErr(err));
        }
        if (typeof error === 'function') error(err);
    };
    if (isV2) {
        url = apiV2 + path;
        header.Accept = /sd/.test(window.location.hostname) ?
            'application/vnd.shendeng.v1+json' :
            'application/vnd.bojin.v1+json';
        if (userStore.token) header.Authorization = 'Bearer ' + userStore.token;
    }
    if(h){
        h(header,userStore.token)
    }
    const ff = {
        method: type && type.toUpperCase() || "GET",
        headers: header,
        mode: 'cors',
    };
    if (postData) ff.body = JSON.stringify(postData);
    return req(url, ff, after, stop, pa, postData, ch || ctx.override.fake).then(json => {
        if (json && (!ch || ch.length !== 0)) {
            if (json.isSuccess) setCache(json);
        }

        if (json) {
            const {self, data, isSuccess, sum} = json || {};
            if (isSuccess && data) {
                if (sum) {
                    data.sum = json.sum
                }
                if (self) {
                    self.isSelf = 1;
                    data.self = json.self;
                }
            }
        }

        if (after) {
            const d = after.call(ctx, json, orig)
            if (d) json = d;
        }
        if (json) {
            if (!json.isSuccess) {
                const {data: {code} = {}} = json
                if (json.status_code === 401 || code === -1 || code === -2) {
                    return f401(json)
                }
                if (json.type === 'loginTimeout') {
                    store.userStore.clear();
                } else return whenFail(json, err)
            } else {
                if (done) {
                    const nt = done(json && json.data, orig, clean);
                    if (Array.isArray(nt)) {
                        const [ap, pm] = nt;
                        setTimeout(() => {
                            getData(ap, pm)
                        }, 10);
                    }
                }
                if ('function' === typeof success) success(json.data, orig, clean);
            }
        } else {
            whenFail(json)
        }
    }).catch((er) => {
        console.log(url);
        const {data = {}, status_code, message} = er;
        if (er && er.status_code) {
            if (status_code === 401) {
                return f401()
            }
            er.status = er.status_code;
        }
        if ('/mobile-announcements' === path) return;
        if (er) {
            const error = data && (data.error || data.data || data.msg) || er.status && ('连接异常:' + er.status) || message;
            er.data = Object.assign({error}, data);
            whenFail(er, err)
        }
    });
};


export const fakeNumber = (fn = a => a) => {
    const d = new Date();
    const today = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    const now = Date.now();
    const dur = now - today;
    const fix = Math.sin(now) * 100;
    return fn(dur / 10 + 1000000 + fix);
};


export const limitBets = function () {
    const cache = {};

    function padding(v, n) {
        if (n <= (v + '').length) return '|' + v;
        return '|' + v + '|' + (Math.pow(10, n) + v + '').substr(1)
    }

    function build(v) {
        const l = v.length;
        if (cache[l]) return cache[l];
        let s = '';
        for (let i = 0, m = Math.pow(10, l + 1); i < m; i++) {
            s += padding(i, l)
        }
        return cache[l] = s.substr(1);
    }

    function arrCopy(a, b) {
        a.forEach((c, i) => {
            const d = b[i];
            if (Array.isArray(c)) {
                arrCopy(c, d)
            } else {
                b[i] = c;
            }
        })
    }

    return function (bs, fn) {
        const old = JSON.parse(JSON.stringify(bs));
        if (bs.length) {
            const {dantuo, dantuoNum: limit, getNum, id} = this;
            const f = arr => {
                if (!fn) {
                    return build(arr[0])
                } else {
                    arr = JSON.parse(JSON.stringify(arr));
                    arr.forEach((a, i) => {
                        if (Array.isArray(a)) arr[i] = f(a);
                        else arr[i] = 1
                    });
                    if (dantuo && limit) {
                        const b = arr[0] || [];
                        for (let i = limit, l = b.length; i < l; i++) {
                            b[i] = -1;
                        }
                    }
                }
                return arr;
            };
            if (fn) fn();
            const recover = () => {
                if (fn) arrCopy(old, bs);
                Tool.alert('', '该玩法投注注数不能超过总注数的80%，您已超过 请修改，谢谢。');
                return true;
            };
            if (/^k3|zusan|zuliu/.test(id)) return;
            if (id === 'sscyixingdingweidanfushi') {
                for (let i = 0, l = bs.length, m = bs[0].length; i < l; i++) {
                    const ro = bs[i];
                    for (let j = 0; j < m; j++) {
                        if (ro.reduce((a, b) => {
                            return a + (b === 1)
                        }, 0) > 7) {
                            return recover();
                        }
                    }
                }
            } else if (getNum(bs) * 100 / getNum(f(bs)) > 80) {
                return recover();
            }
        }
    }
}();
const hookCache = {};

function hCache(key, m) {
    if (!key) return m;
    const a = hookCache[key] || m;
    hookCache[key] = a;
    return a;
}

const sp = {}
const sSp = (k1, k2, v) => {
    const o = sp[k1] = sp[k1] || {};
    o[k2] = o[k2] || v;
    return o[k2]
}

export function useQuery(api) {
    const [r, rr] = useState([0, null, null]);
    const query = (param, success, error) => {
        rr([1, null, null])
        getData('@' + api, param, v => {
            if (success) success(v)
            rr([0, v, null])
        }, (v) => {
            if (error) error(v)
            rr([0, null, v])
        })
    }
    return useMemo(() => [query, ...r], [api, r])
}

/***
 *  批处理请求
 * @param config
 */
export const seqQuery = (config) => {
    const {process, done, fail, skip = 0} = config
    return (...qs) => {
        const c = [];
        qs.forEach(d => {
            const [api, params = [undefined]] = d;
            [].concat(params).forEach(p => c.push(
                {api, param: p}
            ))
        })
        const status = {
            total: c.length,
            finished: 0,
            failed: 0,
            results: [],
            result: {},
            get finish() {
                return this.finished === this.total
            }
        }
        const po = (i) => {
            if (i) status.finished++;
            if (process) process(status)
        }
        const next = (ps = []) => {
            const cf = ps.shift();
            if (!cf) return;
            if (!status.finished) {
                po(0);
            }
            const {api, param} = cf;
            getData(api && '@' + api, typeof param === "function" ? param(status.result) : param, (da) => {
                    status.results.push(status.result = da);
                    po(1);
                    if (ps.length) {
                        next(ps);
                    } else {
                        done && done(da)
                    }
                },
                (err) => {
                    status.result = err;
                    status.failed++;
                    po(1);
                    if (skip) {
                        next(ps);
                    } else {
                        fail && fail(err);
                    }
                })
        }
        next(c);
    }
}

export const change = (c, f) => ({target: {value}}) => c(f ? f(value) : value);
export const trim = (v) => v.replace(/^\s+|\s+$/g, '');
export const val = v => v || undefined;
export const isAgentPage = () => {
    return /\/agent/.test(window.location.pathname);
}


const mg = (a, b) => {
    b.forEach(d => {
        if (a.find(e => JSON.stringify(e) === JSON.stringify(d))) return;
        a.push(d);
    })
}

export const useCacheDate = (data, marge = mg) => {
    const d = useMemo(() => [], []);
    return useMemo(() => {
        if (Array.isArray(data)) (marge(d, data))
        return [
            d.slice(),
            () => d.length = 0
        ]
    }, [data])
}


export const widthStore = (fn) => {
    return observer(props => fn(store, props))
}

export const fmtErr = (err, defaultText) => {
    let s = '';
    if (typeof err === 'string') s = err;
    else {
        const {response: {body = {}} = {}, error: er0} = err || {};
        const {
            error,
            message,
            msg: m1,
            data: {error: er, message: msg, msg: m} = {}
        } = err && err.data || body || err || {};
        const {status_code, message: msg2} = err || {};
        s = (status_code ? "[" + status_code + "]" : "") + (m || m1 || msg || message || error || er || msg2 || er0 ||'');
    }
    //请求失败
    if (/(Load failed|preflight response|failed to fetch|Internal Server Error|Network request failed)/gi.test(s)) s = '';
    if (/Aborted$|^网络连接已|请求超时|request timeout|request time out|Access-Control/ig.test(s)) s = '';// todo：已经频闭超时错误
    return s || defaultText ||''
};
export const colHandel = (n, cols, role) => {
    const o = [];
    n.forEach(ks => {
        const ss = [].concat(ks)
        const bb = [];
        ss.forEach(k => {
            const v = cols && cols[k];
            if (!v) return;
            const [name, key] = v;
            const b = {name}
            if (typeof key === 'function') b.cell = key;
            else b.key = key;
            bb.push(b);
        })
        if (bb.length === 1) o.push(bb[0]);
        else o.push(bb)
    })
    return isAgentPage() ? [{
        name: '用户名', cell({username, is_agent}) {
            let ico;
            if (is_agent && role) ico = <i className={'i-role' + (is_agent ? ' a' : '')}>{is_agent ? '代' : '玩'}</i>
            return <div>{ico}<span>{username}</span></div>
        }
    }].concat(o) : o;
}
export const dateStr = (v, suffix = '', jo = '-') => {
    const d = v ? new Date(v) : new Date()
    const c = c => (c + 100 + '').substr(1);
    return [d.getFullYear(), c(d.getMonth() + 1), c(d.getDate())].join(jo) + suffix
}

export const animate = (vv = [], {
    t = 1,
    r = 0,
    done,
    next
}) => {
    let [a = 0, b = 0] = vv;
    let e = 1;
    let c = 0;
    let stop = 0;
    const v = 60 * t;
    const step = (b - a) / v;
    const run = () => {
        if (stop) return;
        if (!window.stopAni) {
            a = a + e * step;
            c++;
            if (c >= v) {
                if (r) {
                    e = 0 - e;
                    c = 0;
                } else return done && done();
            }
            next && next(a, () => stop = 1);
        }
        requestAnimationFrame(run)
    }
    run();
    return () => {
        stop = 1
    };
}
/***
 * @param {number} l
 * @returns {string}
 */
export const randomStr = (l = 8) => {
    let v = l;
    const a = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const x = [];
    while (v-- > 0) {
        x.push(a[Math.floor(Math.random() * 52)])
    }
    const r = () => x[(Math.floor(Math.random() * Date.now() * 100000)) % l] = Math.floor(Math.random() * 10);
    while (v++ < l * 0.7) r();
    return x.join('');
}
export const mns = v => {
    let n = v;
    const now = new Date();
    const [y, m] = [now.getFullYear(), now.getMonth()];
    const x = [];
    while (n) {
        const mm = m - n;
        n--;
        const d = new Date(y, mm, 1);
        const e = new Date(y, mm + 1, 0);
        x.push([mm, fixD3(d) + '-' + fixD3(e)]);
    }
    return [x, y, m]
}
export const getApi = o => {
    const {hostname} = window.location;
    const domain = (/(https?:\/\/)?(\w+\.\w+)$/.exec(o || hostname) || [])[2];
    if (domain) return 'https://api.' + domain;
}

export const hCurrency = v => {
    const p = [];
    let c = '';
    let d = 0;
    if (v) v.split('').forEach(a => {
        const isD = /\d/.test(a);
        if ((isD && d) || (!isD && !d)) c += a;
        else {
            p.push([c, d])
            c = a;
            d = isD;
        }
    });
    if (c) p.push([c, d]);

    return p.length ? <>{
        p.map(([v, d], i) => {
            return d ? <b key={i}>{v}</b> : v
        })
    }</> : v
}

export const randArr = (a, n) => {
    if (!n) n = a.length;
    const b = [];
    const c = a.slice()
    while (b.length < n && c.length > 0) {
        const idx = Math.floor(Math.random() * c.length);
        b.push(c.splice(idx, 1)[0])
    }
    return b;
}
export const getRegCode = () => {
    const u = window.location.hostname;
    const a = (/^(\w{4,8})\.\w+\.\w+$/.exec(u) || [])[1];
    if (a) return a;
}
export const halfUnit = a => /\.0*5$/.test(a)


export const useCurrentIssue = (id, cur = '') => {
    const ctx = useMemo(() => ({t: 0, next: 0}), [])
    const [issue, sIssue] = useState(cur);
    const [q, , d, e] = useQuery('getIssue')
    const qu = () => q({
        lottery_id: id,
        is_game_numbers: 0,
        is_need_last_winnuber: 1
    })
    useEffect(() => {
        if (!cur) return;
        qu()
        ctx.t = setInterval(() => {
            if (ctx.next && ctx.next <= Date.now()) {
                ctx.next = 0;
                qu()
            }
        }, 1e3);
        return () => clearInterval(ctx.t);
    }, [id])
    useEffect(() => {
        if (!cur) return;
        if (d) {
            const {cur_issue, cur_issue_time, cur_time} = d;
            ctx.next = Date.now() + Math.max((cur_issue_time - cur_time) * 1e3, 3e3);
            if (issue !== cur_issue) {
                sIssue(cur_issue)
            }
        } else if (e) {
            ctx.next = Date.now() + 5e3;
        }
    }, [d, e])
    return issue;
}
const w = {
    get state() {
        return w.cli ? w.cli.readyState : 3
    },
    tk: '',
    t: -1,
    cli: null,
    listener: {},
    task: [],
    send: d => {
        if (w.cli) {
            if (w.state === 1) {
                w.cli.send(JSON.stringify(d));
                return w;
            }
        }
        if (w.tk) {
            w.task.push(() => w.cli.send(JSON.stringify(d)));
        }
        return w;
    },
    close() {
        w.listener = {};
        w.tk = "";
        try {
            w.cli.close();
        } catch (e) {
        }
        w.cli = null;
        return w;
    },
    connect: (token) => {
        if (w.state < 2) return w;
        clearTimeout(w.t);
        w.t = -1;
        if (w.cli) {
            return w;
        }
        if (token) {
            w.tk = token;
            const {WebSocket, location: {host}} = window;
            const c = w.cli = new WebSocket('wss://' + host + '/lp/?token=' + token);
            c.onmessage = ({data: da = ""}) => {
                try {
                    const d = JSON.parse(da);
                    const {type, data, available} = d;
                    const dd = data || available
                    const ex = {...d};
                    delete ex.data;
                    delete ex.type;
                    if (type && dd) {
                        const {listener = {}} = w;
                        const ls = listener[type] || [];
                        ls.forEach(f => f(dd, ex));
                    }
                } catch (e) {
                }
            }
            c.onclose = () => {
                w.cli = null;
                console.log('ws disconnect!');
                w.t = setTimeout(() => w.connect(token), 5e3);
            }
            c.onopen = () => {
                console.log('ws connect!');
                if (w.task) {
                    w.task.forEach(f => f())
                    w.task.length = 0;
                }
            }
            c.onerror = e => {
                console.error(e);
                w.t = setTimeout(() => w.connect(token), 5e3);
            }
        }
        return w;
    },

    subscribe: (type, fn) => {
        const {listener} = w;
        (listener[type] = (listener[type] || [])).push(fn);
        return w;
    },
    unsubscribe: (type, fn) => {
        const {listener} = w;
        const fs = listener[type] || [];
        if (fn) {
            const idx = fs.indexOf(fn);
            if (idx !== -1) fs.splice(idx, 1);
        } else fs.length = 0;
        return w;
    }
}
export const WS = w;


const autoCleanCache =()=>{
    Object.keys(localStore).forEach(n => {
        try {
            const {t} = JSON.parse(localStore[n]);
            if(t+ 24*3600000 < Date.now()){
                localStore.removeItem(n)
            }
        }catch (e){

        }
    })
    setTimeout(autoCleanCache,1e4);
}

autoCleanCache()

const getPay = (name,key) => {
    fetch(getApi(userStore.domain) + '/pay/list/'+name+'.json')
        .then(res => res.json())
        .then(function ({domains = []}) {
            if (Array.isArray(domains)) {
                let best = '';
                domains.forEach(a => {
                    const m = new Image()
                    m.onload = () => {
                        if (!best) {
                            best = a;
                            localStore[key] = a;
                        }
                    }
                    m.src = '//' + a + '/favicon.ico?' + Math.random();
                })
            }
        }).catch((e) => {
    })
    setTimeout(getPay, 1e3 * 60 * 10,name,key);
}
getPay('domains', 'payUrl');
getPay('npdomains', 'nPayUrl');
getPay('usdtdomains', 'uPayUrl');